'use client'

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LOCAL_STORAGE_KEY_USER } from '@/constants/localStorage'

export interface User {
  token: string
  userInfo: null | any
}

interface UserStore extends User {
  setUser: (user: Partial<User>) => void
  signOut: () => void
}

const defaultUserInfo: User = {
  token: '',
  userInfo: null,
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => {
      return {
        ...defaultUserInfo,

        setUser(user) {
          set((prev) => ({
            ...prev,
            ...user,
          }))
        },

        signOut() {
          set((prev) => {
            return {
              ...prev,
              ...defaultUserInfo,
            }
          })
        },
      }
    },
    {
      name: LOCAL_STORAGE_KEY_USER,
    },
  ),
)
